import create from 'zustand';
import { AuthModalStore } from './types';

const useAuthModalStore = create<AuthModalStore>((set) => ({
  visible: false,
  tradingModalConfig: null,
  showModal: (tradingModalConfig = null) => {
    set({ tradingModalConfig, visible: true });
  },
  closeModal: () => {
    set({ tradingModalConfig: null, visible: false });
  },
}));

export default useAuthModalStore;
